<div class="page-section-main-container">
    <div class="form-fields" *ngFor="let data of demographicEditForm; let i = index">
        <ion-item class="form-input-container">
            <label class="form-label">{{ data['title'] }}</label>
            <div class="input-section">
                <input type="text" [value]="data['value']" readonly class="form-input disabled">
            </div>
        </ion-item>
    </div>
</div>